class ContentTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}

	toggle (event, element) {
		let container = element.parentNode.parentNode.querySelector('.post-row-collection')
		if (container.classList.contains('active')) {
			container.classList.remove('active')
			element.classList.remove('open')
		} else {
			element.classList.add('open')
			container.classList.add('active')
		}
	}

	getHtml (post) {

		const image = post.img ? /* html */ `
			<picture>
				<img src="${post.img}" alt="${post.title}" class="blog-img">
			</picture>
		` : ''
		return /* html */ `
			 <div class = " blog-item-wrapper" style="height:510px;">
				<div class="blog-item">
					<div class="blog-img-wrapper">
            			<a class="" href="${post.link}" >${image}</a>
           			</div>
					<div class="inner-wrapper">
						<div class="blog-text">
							<a class="blog-title-link" href="${post.link}" title="${post.title}" >
								<h3 class="blog-title">${post.title}</h3>
							</a>
						</div>
						<p class="blog-readmore">${post.text}</p>
						<a class="btn btn-secondary" href="${post.link}" title="Sprawdź nowości od Sievert Polska">Przejdź do wpisu</a>
					</div>
				</div>
			</div>
		`
	}
}

const contentTemplate = new ContentTemplate()
export {
	ContentTemplate,
	contentTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_news_loader/template/ContentTemplate.js